import { render } from "./FormNew.vue?vue&type=template&id=d84d2030"
import script from "./FormNew.vue?vue&type=script&lang=js"
export * from "./FormNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__